'use strict';

angular.module('app.entity.list', [
    'app.entity.service',
    'app.study-context',
    'ui.router',
    'gettext',
]);
